import addAlphaToColor from "./addAlphaToColor"
import lightenDarkenColor from "./lightenDarkenColor"

const setSiteThemeColorFromLocalStorage = () => {
  const json = localStorage.getItem("themeColor")

  const colorPalette = JSON.parse(json || "null")

  if (colorPalette === null) return

  document.querySelector('meta[name="theme-color"]').setAttribute("content", colorPalette.primary)

  const keys = Object.keys(colorPalette)

  keys.forEach(key => {
    const mainColor = colorPalette[key]

    const mainColorDark = lightenDarkenColor(mainColor, -45)

    const mainColorAlpha25 = addAlphaToColor(mainColor, 0.25)

    document.querySelector(":root").style.setProperty(`--color-${key}`, mainColor)

    document.querySelector(":root").style.setProperty(`--color-${key}-dark`, mainColorDark)

    document.querySelector(":root").style.setProperty(`--color-${key}-alpha-25`, mainColorAlpha25)
  })
}

const setSiteThemeColor = (colorPalette) => {
  if (!colorPalette) {
    return setSiteThemeColorFromLocalStorage()
  }

  localStorage.setItem("themeColor", JSON.stringify(colorPalette))

  const keys = Object.keys(colorPalette)

  document.querySelector('meta[name="theme-color"]').setAttribute("content", colorPalette.primary)

  keys.forEach(key => {
    const mainColor = colorPalette[key]

    const mainColorDark = lightenDarkenColor(mainColor, -45)

    const mainColorAlpha25 = addAlphaToColor(mainColor, 0.25)

    document.querySelector(":root").style.setProperty(`--color-${key}`, mainColor)

    document.querySelector(":root").style.setProperty(`--color-${key}-dark`, mainColorDark)

    document.querySelector(":root").style.setProperty(`--color-${key}-alpha-25`, mainColorAlpha25)
  })
}

export default setSiteThemeColor